import { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { doc, setDoc, getDoc } from "firebase/firestore";
import './App.css';

const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export default function AvailabilityPicker() {
  const [slots, setSlots] = useState([]);

  useEffect(() => {
    const fetchAvailability = async () => {
      const user = auth.currentUser;
      if (!user) return;
      const docRef = doc(db, "availability", user.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setSlots(docSnap.data().slots || []);
      }
    };
    fetchAvailability();
  }, []);

  const updateSlot = (day, from, to) => {
    if (!from || !to) return;
    setSlots((prev) => {
      const filtered = prev.filter((slot) => slot.day !== day);
      return [...filtered, { day, from, to }];
    });
  };

  const deleteSlot = (day) => {
    setSlots((prev) => prev.filter((slot) => slot.day !== day));
  };

  const saveAvailability = async () => {
    const user = auth.currentUser;
    if (!user) return;
    const ref = doc(db, "availability", user.uid);
    await setDoc(ref, {
      userId: user.uid,
      slots
    });
    alert("Availability saved.");
  };

  const sortedSlots = [...slots].sort(
    (a, b) => days.indexOf(a.day) - days.indexOf(b.day)
  );

  const formatTime = (time24) => {
    const [hourStr, minute] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${ampm}`;
  };

  return (
    <div className="availability-container">
      <h2 className="availability-title">Set Your Weekly Availability</h2>

      <div className="availability-form">
        {days.map((day) => (
          <div key={day} className="availability-day-row">
            <label className="day-label">{day}</label>
            <input
              type="time"
              id={`from-${day}`}
              className="time-input"
              title={`Start time for ${day}`}
            />
            <input
              type="time"
              id={`to-${day}`}
              className="time-input"
              title={`End time for ${day}`}
            />
            <button
              className="add-slot-btn"
              onClick={() =>
                updateSlot(
                  day,
                  document.getElementById(`from-${day}`).value,
                  document.getElementById(`to-${day}`).value
                )
              }
            >
              ➕ Set Slot
            </button>
          </div>
        ))}
      </div>

      <button onClick={saveAvailability} className="save-availability-btn">
        ✅ Save All Availability
      </button>

      {sortedSlots.length > 0 && (
        <div className="availability-preview">
          <h3>Your Slots</h3>
          <ul className="slots-list">
            {sortedSlots.map((s, i) => (
              <li key={i} className="slot-entry-card">
                <span className="slot-day">{s.day}</span>
                <span className="slot-time">{formatTime(s.from)} - {formatTime(s.to)}</span>
                <button
                  className="delete-slot-btn"
                  onClick={() => deleteSlot(s.day)}
                  title={`Delete ${s.day}'s slot`}
                >
                  <i class="bi bi-x-circle" style={{fontSize: '2rem', color: 'darkred',}}></i>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
